<template>
	<LabeledFieldLayout
		class="labeled-textarea-field"
		:is-valid="isValid"
	>
		<template #label>{{ label }}</template>
		<template #default>
			<TeamingTextarea
				:class="inputClassName"
				:disabled="disabled"
				:focus="focus"
				:isValid="isValid"
				:name="name"
				:placeholder="placeholder"
				:selection="selection"
				:value="value"
				@keydown="onKeyDown"
				v-on="bubble( `blur`, `focus`, `input` )"
			/>
		</template>
	</LabeledFieldLayout>
</template>

<script>
import * as KeyCode from "keycode-js";

import EventsMixin from "../../mixins/EventsMixin";
import LabeledFieldLayout from "./LabeledFieldLayout.vue";
import TeamingTextarea from "../TeamingTextarea.vue";

const { CODE_ENTER, CODE_RETURN, } = KeyCode;
const isEnter = event => [ CODE_ENTER, CODE_RETURN, ].includes( event.code );

export default {
	name: "LabeledInputField",
	mixins: [ EventsMixin, ],
	emits: [ "input", "enterKey", "focus", "blur", ],
	components: {
		LabeledFieldLayout,
		TeamingTextarea,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		focus: {
			type: Boolean,
			default: false,
		},
		inputClassName: {
			type: String,
			default: "",
		},
		isValid: {
			type: Boolean,
			default: true,
		},
		label: {
			type: String,
			default: "",
		},
		name: {
			type: String,
			default: "",
		},
		placeholder: {
			type: String,
			default: "",
		},
		selection: {
			type: Array,
			default: () => [],
		},
		value: {
			type: String,
			default: "",
		},
	},
	methods: {
		async onKeyDown( e ) {
			if ( !e.shiftKey && isEnter( e ) ) {
				e.preventDefault();
				e.stopPropagation();
				this.$emit( "enterKey", e );
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
